const Magnifier = ({ showMagnifier, zoomLevel, url, position }) => {
  return (
    <div className="lg:col-span-3 p-6 bg-gray-100 border-l border-gray-300">
      <div className="sticky top-4 bg-white rounded-lg shadow-xl">
        <div className="bg-gradient-to-r from-blue-600 to-blue-700 text-white px-4 py-3 rounded-t-lg">
          <div className="flex items-center justify-between">
            <span className="font-semibold">🔍 Zoomed View</span>
            <span className="bg-white bg-opacity-20 px-2 py-1 rounded text-xs">{zoomLevel}x</span>
          </div>
          <p className="text-xs text-blue-100 mt-1">Hover anywhere - including edges</p>
        </div>

        {showMagnifier ? (
          <div
            className="w-full h-96 rounded-b-lg overflow-hidden"
            style={{
              backgroundImage: `url(${url})`,
              backgroundPosition: `${position.x}% ${position.y}%`,
              backgroundSize: `${zoomLevel * 100}%`,
              backgroundRepeat: "no-repeat",
              imageRendering: "-webkit-optimize-contrast",
              filter: "contrast(1.1)",
            }}
          />
        ) : (
          <div className="w-full h-96 rounded-b-lg flex items-center justify-center bg-gray-50">
            <div className="text-center">
              <div className="text-4xl mb-2">👆</div>
              <p className="text-gray-500 text-sm">Hover over image</p>
              <p className="text-gray-400 text-xs mt-1">to see zoomed view</p>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};
export default Magnifier;
